import { render, staticRenderFns } from "./BookEdit.vue?vue&type=template&id=2bb7794a&scoped=true"
import script from "./BookEdit.vue?vue&type=script&lang=js"
export * from "./BookEdit.vue?vue&type=script&lang=js"
import style0 from "./BookEdit.vue?vue&type=style&index=0&id=2bb7794a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7794a",
  null
  
)

export default component.exports